export const format = (formatString, ...strings) => {
    return strings.reduce((acc, curr, index) => {
        return acc.replace('{' + index + '}', curr)
    }, formatString)
}

export const isNullOrWhiteSpace = (str) => {
    return (
        str === undefined ||
        str === null ||
        typeof str !== 'string' ||
        str.match(/^ *$/) !== null
    )
}
